/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why didn't the alarm sound?`)
};

const es_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué no sonó la alarma?`)
};

const de_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ertönte der Alarm nicht?`)
};

const nl_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom klonk het alarm niet?`)
};

const fr_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi l’alarme n’a-t-elle pas sonné ?`)
};

const it_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché l'allarme non ha suonato?`)
};

const pt_br2_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o alarme não tocou?`)
};

const pt_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o alarme não tocou?`)
};

const ja_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アラームが鳴らなかったのはなぜですか？`)
};

const zh_timer_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么闹铃没有响？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq4_q", locale)
	if (locale === "en") return en_timer_hub_faq4_q(inputs)
	if (locale === "es") return es_timer_hub_faq4_q(inputs)
	if (locale === "de") return de_timer_hub_faq4_q(inputs)
	if (locale === "nl") return nl_timer_hub_faq4_q(inputs)
	if (locale === "fr") return fr_timer_hub_faq4_q(inputs)
	if (locale === "it") return it_timer_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq4_q(inputs)
	if (locale === "pt") return pt_timer_hub_faq4_q(inputs)
	if (locale === "ja") return ja_timer_hub_faq4_q(inputs)
	return zh_timer_hub_faq4_q(inputs)
};